__turbopack_context__.v({
  "button": "white-module-scss-module__kxjgBW__button" + " " + __turbopack_context__.i(693367)["block"],
  "complete": "white-module-scss-module__kxjgBW__complete" + " " + __turbopack_context__.i(693367)["complete"],
  "medium": "white-module-scss-module__kxjgBW__medium" + " " + __turbopack_context__.i(693367)["medium"],
  "playing": "white-module-scss-module__kxjgBW__playing" + " " + __turbopack_context__.i(693367)["playing"],
  "small": "white-module-scss-module__kxjgBW__small" + " " + __turbopack_context__.i(693367)["small"],
});
